import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const statesAdapter = getAdapter({ idFieldName: 'value' });

const statesSlice = createSlice({
  name: 'states',
  initialState: statesAdapter.getInitialState(),
  reducers: {
    setStates: (state, { payload: { states } }) => {
      statesAdapter.setAll(state, states);
    },
  },
});

const selectors = statesAdapter.getSelectors(({ states }) => states);

export const getStates = (state) => selectors.selectAll(state);

export const {
  setStates,
} = statesSlice.actions;

export default statesSlice.reducer;
